(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mdl-parure-demo"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (scope) => {
      const root = scope?.matches?.('[data-mdl-parure-demo]')
        ? scope
        : scope?.querySelector?.('[data-mdl-parure-demo]') || document.querySelector('[data-mdl-parure-demo]');

      if (!root || root.dataset.mdlParureReady === 'true') return;
      root.dataset.mdlParureReady = 'true';

      const preset = root.querySelector('[data-parure-preset]');
      const customPanel = root.querySelector('[data-parure-custom]');
      const duvetSelect = root.querySelector('[data-component="duvet"]');
      const pillowSelect = root.querySelector('[data-component="pillow"]');
      const fittedSelect = root.querySelector('[data-component="fitted"]');
      const pillowQuantity = root.querySelector('[data-pillow-quantity]');
      const totals = root.querySelectorAll('[data-parure-total]');
      const availability = root.querySelector('[data-parure-availability]');
      const message = root.querySelector('[data-parure-message]');
      const addButton = root.querySelector('[data-parure-add]');
      const cartLink = root.querySelector('[data-parure-cart-link]');
      const colorButtons = [...root.querySelectorAll('[data-parure-color]')];
      const title = root.querySelector('[data-parure-title]');
      const colorName = root.querySelector('[data-parure-color-name]');
      const colorLabels = root.querySelectorAll('[data-parure-color-label]');
      const duvetDescription = root.querySelector('[data-parure-description-duvet]');
      const pillowDescription = root.querySelector('[data-parure-description-pillow]');
      const fittedDescription = root.querySelector('[data-parure-description-fitted]');
      const gallery = root.querySelector('.mdl-parure-demo__gallery');
      const galleryItems = [...root.querySelectorAll('.mdl-parure-demo__gallery-item')];
      const rootPath = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      let colorLoading = false;
      let colorRequestId = 0;

      const formatMoney = (cents) => new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: root.dataset.currency || 'EUR'
      }).format(cents / 100);

      const priceToCents = (price) => {
        const value = Number(String(price ?? '').replace(',', '.'));
        if (!Number.isFinite(value)) return 0;
        return Number.isInteger(value) && value > 1000 ? value : Math.round(value * 100);
      };

      const normalizeTitle = (value) => String(value || '')
        .toLowerCase()
        .replace(/×/g, 'x')
        .replace(/\s+/g, '')
        .replace(/cm/g, '');

      const matchesSize = (variant, width, height) => {
        const titleValue = normalizeTitle(variant?.title);
        const paddedWidth = String(width).padStart(3, '0');
        const paddedHeight = String(height).padStart(3, '0');
        return [
          `${width}x${height}`,
          `${paddedWidth}x${paddedHeight}`,
          `${width}/${height}`,
          `${paddedWidth}/${paddedHeight}`
        ].some((size) => titleValue.includes(size));
      };

      const findVariantBySize = (product, width, height) => product?.variants?.find((variant) => matchesSize(variant, width, height));

      const selected = (select) => {
        const option = select?.options[select.selectedIndex];
        if (!option || !option.value) return null;
        return {
          id: option.value,
          title: option.textContent.trim().replace(' · indisponible', ''),
          price: Number(option.dataset.price || 0),
          available: option.dataset.available === 'true'
        };
      };

      const setSelectValue = (select, value) => {
        if ([...select.options].some((option) => option.value === String(value))) {
          select.value = String(value);
        }
      };

      const getPresetConfiguration = (value) => {
        const configurations = {
          'square-240': { duvet: root.dataset.duvet240, pillow: root.dataset.pillowSquare, quantity: '2' },
          'rectangle-240': { duvet: root.dataset.duvet240, pillow: root.dataset.pillowRectangle, quantity: '2' },
          'square-260': { duvet: root.dataset.duvet260, pillow: root.dataset.pillowSquare, quantity: '2' },
          'rectangle-260': { duvet: root.dataset.duvet260, pillow: root.dataset.pillowRectangle, quantity: '2' }
        };
        return configurations[value];
      };

      const updatePresetData = (products) => {
        const duvet240 = findVariantBySize(products.duvet, 240, 220);
        const duvet260 = findVariantBySize(products.duvet, 260, 240);
        const pillowSquare = findVariantBySize(products.pillow, 65, 65);
        const pillowRectangle = findVariantBySize(products.pillow, 50, 75);
        root.dataset.duvet240 = duvet240 ? String(duvet240.id) : '';
        root.dataset.duvet260 = duvet260 ? String(duvet260.id) : '';
        root.dataset.pillowSquare = pillowSquare ? String(pillowSquare.id) : '';
        root.dataset.pillowRectangle = pillowRectangle ? String(pillowRectangle.id) : '';
      };

      const optionForVariant = (variant) => {
        const option = document.createElement('option');
        option.value = String(variant.id);
        option.dataset.price = String(priceToCents(variant.price));
        option.dataset.available = String(Boolean(variant.available));
        option.textContent = `${variant.title || 'Format standard'}${variant.available ? '' : ' · indisponible'}`;
        return option;
      };

      const findPreferredVariant = (variants, preferredId, preferredTitle) => {
        return variants.find((variant) => String(variant.id) === String(preferredId))
          || variants.find((variant) => normalizeTitle(variant.title) === normalizeTitle(preferredTitle))
          || variants.find((variant) => variant.available)
          || variants[0];
      };

      const populateSelect = (select, variants, preferredId, preferredTitle, withEmptyOption) => {
        const options = Array.isArray(variants) ? variants : [];
        const preferred = findPreferredVariant(options, preferredId, preferredTitle);
        select.innerHTML = '';

        if (withEmptyOption) {
          const emptyOption = document.createElement('option');
          emptyOption.value = '';
          emptyOption.dataset.price = '0';
          emptyOption.dataset.available = 'true';
          emptyOption.textContent = 'Ne pas ajouter de drap housse';
          select.appendChild(emptyOption);
        }

        options.forEach((variant) => select.appendChild(optionForVariant(variant)));
        if (preferred) setSelectValue(select, preferred.id);
        if (withEmptyOption && !preferredId && !preferredTitle) select.value = '';
      };

      const productDescription = (html, fallback, wordLimit) => {
        const template = document.createElement('template');
        template.innerHTML = html || '';
        const text = (template.content.textContent || '').replace(/\s+/g, ' ').trim();
        if (!text) return fallback;
        const words = text.split(' ');
        return words.length > wordLimit ? `${words.slice(0, wordLimit).join(' ')}…` : text;
      };

      const imageUrl = (value) => {
        if (!value) return '';
        return String(value).startsWith('//') ? `https:${value}` : String(value);
      };

      const updateGallery = (products, colorLabel) => {
        const images = [
          ...(products.duvet.images || []).slice(0, 4),
          ...(products.pillow.images || []).slice(0, 4),
          ...(products.fitted.images || []).slice(0, 4)
        ].map(imageUrl).filter(Boolean);
        let visibleIndex = 0;

        galleryItems.forEach((item) => {
          const url = images[visibleIndex];
          const link = item.querySelector('a');
          const image = item.querySelector('img');
          item.hidden = !url;
          item.classList.toggle('mdl-parure-demo__gallery-item--featured', Boolean(url) && visibleIndex === 0);
          if (!url || !image) return;
          image.src = url;
          image.removeAttribute('srcset');
          image.alt = `Parure de lit Onéa ${colorLabel}`;
          image.loading = visibleIndex === 0 ? 'eager' : 'lazy';
          if (link) link.href = url;
          visibleIndex += 1;
        });

        if (gallery) gallery.setAttribute('aria-label', `Photos de la parure Onéa ${colorLabel}`);
      };

      const fetchProduct = async (handle) => {
        const response = await fetch(`${rootPath}products/${encodeURIComponent(handle)}.js`, {
          headers: { Accept: 'application/json' }
        });
        if (!response.ok) throw new Error('Impossible de charger cette couleur.');
        return response.json();
      };

      const update = () => {
        const duvet = selected(duvetSelect);
        const pillow = selected(pillowSelect);
        const fitted = selected(fittedSelect);
        const quantity = Number(pillowQuantity.value || 2);
        const valid = Boolean(duvet?.available && pillow?.available && (!fitted || fitted.available));
        const totalCents = (duvet?.price || 0) + ((pillow?.price || 0) * quantity) + (fitted?.price || 0);
        const configurationLabel = preset.options[preset.selectedIndex]?.textContent.trim() || 'Parure personnalisée';

        customPanel.hidden = preset.value !== 'custom';
        totals.forEach((element) => {
          element.textContent = formatMoney(totalCents);
        });
        addButton.disabled = colorLoading || !valid;
        availability.textContent = colorLoading
          ? 'Chargement de la couleur…'
          : (valid ? '' : 'Cette composition contient un article indisponible.');
        addButton.dataset.configuration = configurationLabel;
      };

      const switchColor = async (button) => {
        if (colorLoading || button.getAttribute('aria-pressed') === 'true') return;
        const requestId = ++colorRequestId;
        const previous = {
          duvet: selected(duvetSelect),
          pillow: selected(pillowSelect),
          fitted: selected(fittedSelect)
        };
        const color = {
          key: button.dataset.parureColor,
          label: button.dataset.colorLabel,
          duvetHandle: button.dataset.colorDuvetHandle,
          pillowHandle: button.dataset.colorPillowHandle,
          fittedHandle: button.dataset.colorFittedHandle
        };

        colorLoading = true;
        message.textContent = '';
        colorButtons.forEach((colorButton) => colorButton.setAttribute('aria-busy', 'true'));
        update();

        try {
          const [duvet, pillow, fitted] = await Promise.all([
            fetchProduct(color.duvetHandle),
            fetchProduct(color.pillowHandle),
            fetchProduct(color.fittedHandle)
          ]);
          if (requestId !== colorRequestId) return;

          const products = { duvet, pillow, fitted };
          updatePresetData(products);
          const preferredConfiguration = getPresetConfiguration(preset.value);
          populateSelect(
            duvetSelect,
            duvet.variants,
            preferredConfiguration?.duvet || '',
            previous.duvet?.title,
            false
          );
          populateSelect(
            pillowSelect,
            pillow.variants,
            preferredConfiguration?.pillow || '',
            previous.pillow?.title,
            false
          );
          populateSelect(fittedSelect, fitted.variants, '', previous.fitted?.title, true);
          if (preset.value !== 'custom') {
            pillowQuantity.value = '2';
            fittedSelect.value = '';
          }

          root.dataset.colorKey = color.key;
          root.dataset.colorLabel = color.label;
          root.dataset.colorDuvetHandle = color.duvetHandle;
          root.dataset.colorPillowHandle = color.pillowHandle;
          root.dataset.colorFittedHandle = color.fittedHandle;
          if (title) title.textContent = `Parure de lit Percale ${color.label} Onéa`;
          if (colorName) colorName.textContent = color.label;
          colorLabels.forEach((label) => { label.textContent = color.label; });
          if (duvetDescription) duvetDescription.textContent = productDescription(duvet.description, 'La percale de coton offre un toucher doux, frais et léger.', 34);
          if (pillowDescription) pillowDescription.textContent = productDescription(pillow.description, 'des taies coordonnées pour une finition harmonieuse.', 20);
          if (fittedDescription) fittedDescription.textContent = productDescription(fitted.description, 'un drap housse assorti.', 20);
          colorButtons.forEach((colorButton) => {
            const isSelected = colorButton === button;
            colorButton.classList.toggle('is-selected', isSelected);
            colorButton.setAttribute('aria-pressed', String(isSelected));
          });
          updateGallery(products, color.label);
          cartLink.hidden = true;
          update();
        } catch (error) {
          message.textContent = error.message || 'Impossible de changer de couleur.';
        } finally {
          colorLoading = false;
          colorButtons.forEach((colorButton) => colorButton.removeAttribute('aria-busy'));
          update();
        }
      };

      preset.addEventListener('change', () => {
        const configuration = getPresetConfiguration(preset.value);
        if (configuration) {
          setSelectValue(duvetSelect, configuration.duvet);
          setSelectValue(pillowSelect, configuration.pillow);
          pillowQuantity.value = configuration.quantity;
          fittedSelect.value = '';
        }
        message.textContent = '';
        cartLink.hidden = true;
        update();
      });

      colorButtons.forEach((button) => {
        button.addEventListener('click', () => switchColor(button));
      });

      [duvetSelect, pillowSelect, fittedSelect, pillowQuantity].forEach((select) => {
        select.addEventListener('change', () => {
          preset.value = 'custom';
          message.textContent = '';
          cartLink.hidden = true;
          update();
        });
      });

      addButton.addEventListener('click', async () => {
        const duvet = selected(duvetSelect);
        const pillow = selected(pillowSelect);
        const fitted = selected(fittedSelect);
        const quantity = Number(pillowQuantity.value || 2);
        const configuration = addButton.dataset.configuration || 'Parure personnalisée';

        if (!duvet?.available || !pillow?.available || (fitted && !fitted.available)) return;

        const properties = {
          Parure: `Onéa Percale ${root.dataset.colorLabel || 'Anthracite'}`,
          Configuration: configuration
        };
        const items = [
          { id: duvet.id, quantity: 1, properties },
          { id: pillow.id, quantity, properties }
        ];

        if (fitted) items.push({ id: fitted.id, quantity: 1, properties });

        addButton.disabled = true;
        message.textContent = 'Ajout de la parure…';
        cartLink.hidden = true;

        try {
          const response = await fetch(rootPath + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items })
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || 'Impossible d’ajouter la parure.');
          message.textContent = 'Parure ajoutée au panier.';
          cartLink.hidden = false;
        } catch (error) {
          message.textContent = error.message || 'Une erreur est survenue.';
        } finally {
          update();
        }
      });

      update();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
    } else {
      initialize(document);
    }

    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mdl_collection_mattress_advisor"] && !Shopify.designMode) return;
  try {
    
  if (false) {
  (() => {
    const STORAGE_KEY = 'mdlMattressAdvisorState';
    const advisors = document.querySelectorAll('[data-mattress-advisor]');
    const comfortHelp = document.querySelector('[data-comfort-help]');
    const comfortFlowRoot = comfortHelp ? comfortHelp.querySelector('[data-comfort-flow]') : null;
    const comfortFlowSteps = comfortFlowRoot ? Array.from(comfortFlowRoot.querySelectorAll('[data-comfort-flow-step]')) : [];
    const comfortResultText = comfortHelp ? comfortHelp.querySelector('[data-comfort-result-text]') : null;
    const comfortResultActions = comfortHelp ? comfortHelp.querySelector('[data-comfort-result-actions]') : null;
    const comfortDisclaimer = comfortHelp ? comfortHelp.querySelector('[data-comfort-disclaimer]') : null;
    const comfortApply = comfortHelp ? comfortHelp.querySelector('[data-comfort-apply-recommendation]') : null;
    const comfortFlowState = { accueil: '', position: '', poids: '' };

    const showComfortFlowStep = (stepKey) => {
      if (!comfortFlowSteps.length) return;
      comfortFlowSteps.forEach((step) => {
        step.classList.toggle('is-active', step.dataset.comfortFlowStep === stepKey);
      });
      if (comfortResultActions) comfortResultActions.hidden = stepKey !== 'result';
      if (comfortDisclaimer) comfortDisclaimer.hidden = stepKey !== 'result';
    };

    const computeComfortRecommendation = () => {
      let base = 'medium';
      if (comfortFlowState.accueil === 'cocon') base = 'moelleux';
      if (comfortFlowState.accueil === 'equilibre') base = 'medium';
      if (comfortFlowState.accueil === 'tonique') base = 'ferme';
      const p = comfortFlowState.position;
      const w = comfortFlowState.poids;
      if (p === 'ventre') base = 'ferme';
      if (p === 'dos' && base === 'moelleux') base = 'medium';
      if (p === 'cote' && base === 'ferme') base = 'medium';
      if (p === 'mixte' && base === 'moelleux') base = 'medium';
      if (w === 'lourd' && base !== 'ferme') base = 'ferme';
      if (w === 'leger' && base === 'ferme') base = 'medium';
      const labels = { moelleux: 'Moelleux', medium: 'Medium', ferme: 'Ferme' };
      return labels[base] || 'Medium';
    };

    const applyRecommendedComfortToQuiz = () => {
      const rec = computeComfortRecommendation().toLowerCase();
      const comfortStep = document.querySelector('[data-step-kind="comfort"]');
      if (!comfortStep) return;
      const buttons = Array.from(comfortStep.querySelectorAll('.mdl-mattress-advisor__choice[data-answer-key="comfort"]'));
      if (!buttons.length) return;
      const target = buttons.find((button) => {
        const label = (button.dataset.filterLabel || button.textContent || '').toLowerCase();
        if (rec === 'moelleux') return label.includes('moelleux') || label.includes('souple');
        if (rec === 'ferme') return label.includes('ferme') || label.includes('extra');
        return label.includes('medium') || label.includes('médium') || label.includes('équilibr');
      });
      if (target) {
        target.click();
      }
      closeComfortHelp();
    };

    const openComfortHelp = () => {
      if (!comfortHelp) return;
      comfortHelp.hidden = false;
      document.body.classList.add('mdl-comfort-help-open');
      comfortFlowState.accueil = '';
      comfortFlowState.position = '';
      comfortFlowState.poids = '';
      if (comfortFlowRoot) {
        comfortFlowRoot.querySelectorAll('.mdl-comfort-help__choice').forEach((node) => node.classList.remove('is-selected'));
      }
      if (comfortResultText) comfortResultText.textContent = '';
      if (comfortResultActions) comfortResultActions.hidden = true;
      if (comfortDisclaimer) comfortDisclaimer.hidden = true;
      showComfortFlowStep('accueil');
    };

    const closeComfortHelp = () => {
      if (!comfortHelp) return;
      comfortHelp.hidden = true;
      document.body.classList.remove('mdl-comfort-help-open');
    };

    if (comfortHelp) {
      comfortHelp.querySelectorAll('[data-comfort-help-close]').forEach((node) => {
        node.addEventListener('click', closeComfortHelp);
      });
      comfortHelp.addEventListener('click', (event) => {
        if (event.target === comfortHelp) closeComfortHelp();
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !comfortHelp.hidden) closeComfortHelp();
      });
      comfortHelp.addEventListener('click', (event) => {
        const choice = event.target.closest('.mdl-comfort-help__choice');
        if (!choice) return;
        const pick = choice.dataset.comfortPick;
        const value = choice.dataset.value;
        if (!pick || !value) return;
        const step = choice.closest('[data-comfort-flow-step]');
        if (step) {
          step.querySelectorAll('.mdl-comfort-help__choice').forEach((node) => node.classList.remove('is-selected'));
          choice.classList.add('is-selected');
        }
        comfortFlowState[pick] = value;
        if (pick === 'accueil') {
          showComfortFlowStep('position');
          return;
        }
        if (pick === 'position') {
          showComfortFlowStep('poids');
          return;
        }
        if (pick === 'poids') {
          const rec = computeComfortRecommendation();
          if (comfortResultText) {
            comfortResultText.textContent = `Accueil conseillé : ${rec}.`;
          }
          showComfortFlowStep('result');
        }
      });
      if (comfortApply) {
        comfortApply.addEventListener('click', applyRecommendedComfortToQuiz);
      }
    }

    const normalizeSizeLabel = (label) => String(label || '').replace(/\s+/g, ' ').trim();
    const parseSize = (label) => {
      const match = normalizeSizeLabel(label).match(/(\d{2,3})\s*x\s*(\d{3})/i);
      if (!match) return null;
      return {
        width: Number(match[1]),
        length: Number(match[2]),
      };
    };

    const describeWidth = (width, occupancy) => {
      if (occupancy === 'one') {
        if (width >= 120) return 'Solo très spacieux, confort premium';
        if (width >= 100) return 'Solo grand confort, plus de liberté';
        if (width >= 90) return 'Format solo standard, polyvalent';
        return 'Format compact, idéal pour petit espace';
      }
      if (width >= 200) return 'Confort royal pour deux personnes';
      if (width >= 180) return 'Très grand confort à deux';
      if (width >= 160) return 'Confort spacieux pour deux personnes';
      if (width >= 140) return 'Deux personnes, format standard';
      if (width >= 100) return 'Solo large ou couchage compact';
      return 'Une personne, adulte ou adolescent';
    };

    const describeLength = (length) => {
      if (length >= 200) return 'Plus de place en longueur, idéal si vous êtes grand';
      return "Matelas court, pour les personnes de moins d'1m70";
    };

    const buildButton = ({ label, description, count, dataset, iconSvg }) => {
      const button = document.createElement('button');
      button.className = 'mdl-mattress-advisor__choice';
      button.type = 'button';
      button.setAttribute('aria-pressed', 'false');
      Object.entries(dataset).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') button.dataset[key] = String(value);
      });

      const mainNode = document.createElement('span');
      mainNode.className = 'mdl-mattress-advisor__choice-main';
      if (iconSvg) {
        const iconNode = document.createElement('span');
        iconNode.className = 'mdl-mattress-advisor__choice-icon';
        iconNode.setAttribute('aria-hidden', 'true');
        iconNode.innerHTML = iconSvg;
        mainNode.appendChild(iconNode);
      }
      const labelNode = document.createElement('span');
      labelNode.textContent = label;
      mainNode.appendChild(labelNode);
      const descriptionNode = document.createElement('em');
      descriptionNode.textContent = description;
      button.append(mainNode, descriptionNode);
      return button;
    };

    const findProductTarget = (advisor) => {
      const section = advisor.closest('.shopify-section');
      let sibling = section ? section.nextElementSibling : null;
      while (sibling) {
        const id = sibling.id || '';
        if (id.includes('__collection') || sibling.querySelector('facet-filters-form, product-card, .product-card, [data-product-card], .boost-sd__product-item')) {
          return sibling;
        }
        sibling = sibling.nextElementSibling;
      }
      return document.querySelector('facet-filters-form, .boost-sd__collection, [data-products-grid], product-list') || document.querySelector('main');
    };

    const removeSelectionHeading = () => {
      document.querySelectorAll('.mdl-mattress-advisor-selection-heading').forEach((node) => node.remove());
    };

    const injectSelectionHeadingBeforeListing = (advisor) => {
      removeSelectionHeading();
      const target = findProductTarget(advisor);
      if (!target || !target.parentNode) return;
      const heading = document.createElement('h2');
      heading.className = 'mdl-mattress-advisor-selection-heading';
      heading.textContent = 'Votre sélection';
      target.parentNode.insertBefore(heading, target);

      const firstCard = target.querySelector('.boost-sd__product-item, .product-card, [data-product-card], product-card');
      if (firstCard) {
        const headingRect = heading.getBoundingClientRect();
        const cardRect = firstCard.getBoundingClientRect();
        const offset = Math.max(0, Math.round(cardRect.left - headingRect.left));
        heading.style.marginLeft = `${offset}px`;
      }
      return heading;
    };


    const findQuickSizeNavBlock = (advisor) => {
      const section = advisor.closest('.shopify-section');
      let sibling = section ? section.nextElementSibling : null;
      while (sibling) {
        if (
          sibling.querySelector('layer-action[layer-id="collection-filters"]')
          || sibling.textContent.includes('Toutes les tailles')
        ) {
          return sibling;
        }
        sibling = sibling.nextElementSibling;
      }
      return null;
    };

    advisors.forEach((advisor) => {
      if (advisor.dataset.initialized === 'true') return;
      advisor.dataset.initialized = 'true';

      const track = advisor.querySelector('[data-advisor-track]');
      const steps = Array.from(advisor.querySelectorAll('[data-advisor-step]'));
      const collapsed = advisor.querySelector('[data-advisor-collapsed]');
      const expanded = advisor.querySelector('[data-advisor-expanded]');
      const prevButtons = Array.from(advisor.querySelectorAll('[data-advisor-prev]'));
      const nextButtons = Array.from(advisor.querySelectorAll('[data-advisor-next]'));
      const resetButtons = advisor.querySelectorAll('[data-reset-advisor]');
      const mainActionButton = advisor.querySelector('[data-advisor-main-action]');
      const progressNodes = Array.from(advisor.querySelectorAll('[data-advisor-progress]'));
      const dots = Array.from(advisor.querySelectorAll('[data-advisor-dot]'));
      const collapsedSummary = advisor.querySelector('[data-advisor-collapsed-summary]');
      const collectionUrl = advisor.dataset.collectionUrl || window.location.pathname;
      const answers = new Map();
      let currentIndex = 0;
      let panelOpen = false;
      let selectedWidth = null;
      let selectedOccupancy = null;
      const answeredSteps = new Set();
      const autoSkippedSteps = new Set();

      const sizeOptions = Array.from(advisor.querySelectorAll('[data-size-option]')).map((node) => {
        const parsed = parseSize(node.dataset.filterLabel || node.dataset.filterValue);
        if (!parsed) return null;
        return {
          ...parsed,
          param: node.dataset.filterParam,
          value: node.dataset.filterValue,
          label: normalizeSizeLabel(node.dataset.filterLabel || node.dataset.filterValue),
          count: Number(node.dataset.sizeCount || 0),
        };
      }).filter(Boolean);

      const updateMainActionLabel = () => {
        if (!mainActionButton) return;
        const shouldReset = panelOpen || advisor.classList.contains('has-results');
        mainActionButton.textContent = shouldReset ? 'Recommencer' : 'Commencer >';
      };

      const setPanelOpen = (isOpen) => {
        panelOpen = isOpen;
        advisor.classList.toggle('is-collapsed', !isOpen);
        if (collapsed) collapsed.hidden = false;
        if (expanded) expanded.hidden = !isOpen;
        const quickSizeNav = findQuickSizeNavBlock(advisor);
        if (quickSizeNav) {
          quickSizeNav.hidden = isOpen;
        }
        updateMainActionLabel();
      };

      const updateUi = () => {
        if (track) track.style.transform = `translateX(-${currentIndex * 100}%)`;
        const prevDisabled = currentIndex === 0;
        const nextDisabled = currentIndex >= steps.length - 1 || !answeredSteps.has(currentIndex + 1);
        prevButtons.forEach((button) => {
          button.disabled = prevDisabled;
        });
        nextButtons.forEach((button) => {
          button.disabled = nextDisabled;
        });
        if (progressNodes.length) {
          const totalVisible = Math.max(1, steps.length - autoSkippedSteps.size);
          const skippedBefore = Array.from(autoSkippedSteps).filter((idx) => idx < currentIndex).length;
          const visibleIndex = Math.max(1, Math.min(totalVisible, currentIndex - skippedBefore + 1));
          progressNodes.forEach((node) => {
            node.textContent = `${visibleIndex}/${totalVisible}`;
          });
        }
        dots.forEach((dot, index) => dot.classList.toggle('is-active', index === currentIndex));
        updateViewportHeight();
      };

      const updateViewportHeight = () => {
        const viewport = advisor.querySelector('.mdl-mattress-advisor__viewport');
        const activeStep = steps[currentIndex];
        if (!viewport || !activeStep) return;
        viewport.style.height = `${activeStep.offsetHeight}px`;
      };

      const buildSummary = () => {
        if (!collapsedSummary) return;
        collapsedSummary.innerHTML = '';
        const labels = Array.from(answers.values()).map((answer) => answer.summaryLabel || answer.label).filter(Boolean);
        if (!labels.length) {
          advisor.classList.remove('has-results');
          const item = document.createElement('span');
          item.textContent = 'Tous les matelas';
          collapsedSummary.appendChild(item);
          return;
        }
        advisor.classList.add('has-results');
        labels.forEach((label) => {
          const item = document.createElement('span');
          item.textContent = label;
          collapsedSummary.appendChild(item);
        });
      };

      const goTo = (index) => {
        currentIndex = Math.max(0, Math.min(index, steps.length - 1));
        updateUi();
      };

      const goNext = () => {
        goTo(currentIndex + 1);
      };

      const animateExpandToCurrentStep = () => {
        if (!track) return;
        const targetTransform = `translateX(-${currentIndex * 100}%)`;
        track.style.transition = 'none';
        track.style.transform = `translateX(calc(-${currentIndex * 100}% + 4%))`;
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            track.style.transition = 'transform 420ms cubic-bezier(0.22, 1, 0.36, 1)';
            track.style.transform = targetTransform;
          });
        });
      };

      const buildTargetUrl = () => {
        const target = new URL(collectionUrl, window.location.origin);
        target.searchParams.set('sort_by', 'price-ascending');

        answers.forEach((answer) => {
          if (answer.param && answer.value) target.searchParams.append(answer.param, answer.value);
          if (answer.paramMin && answer.valueMin) target.searchParams.set(answer.paramMin, answer.valueMin);
          if (answer.paramMax && answer.valueMax) target.searchParams.set(answer.paramMax, answer.valueMax);
        });

        return target;
      };

      const buildResetUrl = () => {
        const target = new URL(collectionUrl, window.location.origin);
        return target;
      };

      const applyFilters = () => {
        buildSummary();
        setPanelOpen(false);
        advisor.classList.add('is-applying');

        const target = buildTargetUrl();
        const summaryLabels = Array.from(answers.values()).map((answer) => answer.summaryLabel || answer.label).filter(Boolean);
        try {
          window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
            path: target.pathname,
            labels: summaryLabels,
            flash: true,
          }));
        } catch (error) {
          // Storage can be blocked; the native URL filtering still works.
        }

        window.setTimeout(() => {
          window.location.href = target.toString();
        }, 180);
      };

      const selectChoice = (choice, options = {}) => {
        const { auto = false } = options;
        const step = choice.closest('[data-advisor-step]');
        const stepIndex = steps.indexOf(step);
        if (stepIndex < 0) return;

        step.querySelectorAll('.mdl-mattress-advisor__choice').forEach((button) => {
          button.classList.remove('is-selected');
          button.setAttribute('aria-pressed', 'false');
        });
        choice.classList.add('is-selected');
        choice.setAttribute('aria-pressed', 'true');

        const answerKey = choice.dataset.answerKey || String(stepIndex);
        answeredSteps.add(stepIndex);
        if (choice.hasAttribute('data-skip-step')) {
          if (answerKey === 'comfort') {
            answers.set('comfort', {
              label: 'Sans préférence',
              summaryLabel: 'Confort: sans préférence',
            });
          } else {
            answers.delete(answerKey);
          }
          if (answerKey === 'occupancy') {
            selectedOccupancy = null;
            selectedWidth = null;
            answers.delete('width');
            answers.delete('size');
            renderWidthChoices();
            renderLengthChoices();
            maybeAutoAdvanceSingles();
          }
        } else if (choice.dataset.pendingWidth) {
          selectedWidth = Number(choice.dataset.pendingWidth);
          answers.set('width', {
            label: choice.dataset.filterLabel,
            summaryLabel: `${choice.dataset.filterLabel} cm de large`,
          });
          renderLengthChoices();
          maybeAutoAdvanceSingles();
        } else if (answerKey === 'occupancy') {
          selectedOccupancy = choice.dataset.filterValue;
          selectedWidth = null;
          answers.delete('width');
          answers.delete('size');
          answers.set('occupancy', {
            label: choice.dataset.filterLabel,
            summaryLabel: choice.dataset.summaryLabel || choice.dataset.filterLabel,
          });
          renderWidthChoices();
          renderLengthChoices();
          maybeAutoAdvanceSingles();
        } else {
          if (answerKey === 'size') {
            answers.delete('width');
          }
          answers.set(answerKey, {
            param: choice.dataset.filterParam,
            value: choice.dataset.filterValue,
            paramMin: choice.dataset.filterParamMin,
            valueMin: choice.dataset.filterValueMin,
            paramMax: choice.dataset.filterParamMax,
            valueMax: choice.dataset.filterValueMax,
            label: choice.dataset.filterLabel,
            summaryLabel: choice.dataset.summaryLabel || choice.dataset.filterLabel,
          });
        }

        if (stepIndex >= steps.length - 1) {
          window.setTimeout(applyFilters, 220);
          return;
        }

        if (auto) {
          goNext();
          return;
        }
        window.setTimeout(() => {
          goNext();
          maybeAutoAdvanceSingles();
        }, 160);
      };

      const maybeAutoAdvanceSingles = () => {
        let safety = 0;
        while (safety < steps.length) {
          safety += 1;
          const step = steps[currentIndex];
          if (!step) break;
          const choices = Array.from(step.querySelectorAll('.mdl-mattress-advisor__choice')).filter((btn) => {
            if (btn.offsetParent === null) return false;
            if (btn.hasAttribute('data-skip-step')) return false;
            return true;
          });
          if (choices.length !== 1) break;
          autoSkippedSteps.add(currentIndex);
          selectChoice(choices[0], { auto: true });
        }
        updateUi();
      };

      const renderWidthChoices = () => {
        const container = advisor.querySelector('[data-width-choices]');
        if (!container || !sizeOptions.length) return;

        const occupancyFiltered = sizeOptions.filter((option) => {
          if (selectedOccupancy === 'one') return option.width <= 120;
          if (selectedOccupancy === 'two') return option.width >= 140;
          return true;
        });

        const widths = Array.from(new Map(occupancyFiltered.map((option) => [option.width, option])).keys()).sort((a, b) => b - a);
        container.innerHTML = '';
        if (!widths.length) {
          const empty = document.createElement('small');
          empty.className = 'mdl-mattress-advisor__hint';
          empty.textContent = 'Aucune largeur disponible pour ce choix.';
          container.appendChild(empty);
          return;
        }
        widths.forEach((width) => {
          const count = occupancyFiltered.filter((option) => option.width === width).reduce((sum, option) => sum + option.count, 0);
          container.appendChild(buildButton({
            label: `Largeur ${width} cm`,
            description: describeWidth(width, selectedOccupancy),
            count,
            dataset: {
              answerKey: 'width',
              pendingWidth: width,
              filterLabel: String(width),
            },
          }));
        });
      };

      const renderOccupancyChoices = () => {
        const container = advisor.querySelector('[data-occupancy-choices]');
        if (!container) return;
        const twoPeopleIcon = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="8" cy="8" r="3"></circle><circle cx="16" cy="8" r="3"></circle><path d="M2.5 18c0-2.5 2.2-4 5.5-4"></path><path d="M10 18c0-2.5 2.2-4 6-4s6 1.5 6 4"></path></svg>';
        const onePersonIcon = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="7" r="3"></circle><path d="M5 19c0-3 2.8-5 7-5s7 2 7 5"></path></svg>';
        container.innerHTML = '';
        container.appendChild(buildButton({
          label: 'Deux personnes',
          description: 'Pour dormir à deux',
          count: null,
          iconSvg: twoPeopleIcon,
          dataset: {
            answerKey: 'occupancy',
            filterValue: 'two',
            filterLabel: 'Deux personnes',
            summaryLabel: '2 personnes',
          },
        }));
        container.appendChild(buildButton({
          label: 'Une personne',
          description: 'Pour dormir seul',
          count: null,
          iconSvg: onePersonIcon,
          dataset: {
            answerKey: 'occupancy',
            filterValue: 'one',
            filterLabel: 'Une personne',
            summaryLabel: '1 personne',
          },
        }));
      };

      const renderLengthChoices = () => {
        const container = advisor.querySelector('[data-length-choices]');
        const hint = advisor.querySelector('[data-length-hint]');
        if (!container) return;

        const matchingOptions = sizeOptions
          .filter((option) => option.width === selectedWidth)
          .sort((a, b) => b.length - a.length);

        container.innerHTML = '';
        if (hint) {
          hint.textContent = selectedWidth ? `Largeur sélectionnée : ${selectedWidth} cm` : '';
        }

        matchingOptions.forEach((option) => {
          container.appendChild(buildButton({
            label: `${option.length} cm`,
            description: option.length >= 200
              ? "Longueur confort, pour les plus d'1m70"
              : "Matelas court, pour les personnes de moins d'1m70",
            count: option.count,
            dataset: {
              answerKey: 'size',
              filterParam: option.param,
              filterValue: option.value,
              filterLabel: option.label,
              summaryLabel: `${option.width} x ${option.length} cm`,
            },
          }));
        });
        if (!matchingOptions.length && hint) {
          hint.textContent = selectedWidth ? `Aucune longueur disponible pour ${selectedWidth} cm.` : '';
        }
      };

      const decorateComfortIcons = () => {
        const comfortStep = advisor.querySelector('[data-step-kind="comfort"]');
        if (!comfortStep) return;
        const comfortIconByLabel = new Map([
          ['sans préférence', '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12c1.8-2.8 3.5-4.2 5.2-4.2 3.2 0 4.1 8.4 7.2 8.4 1.8 0 3.5-1.4 5.6-4.2"></path><path d="M3 12c2.1 2.8 3.8 4.2 5.6 4.2 3.1 0 4-8.4 7.2-8.4 1.7 0 3.4 1.4 5.2 4.2"></path></svg>'],
          ['personnalisable', '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="2.4"></circle><path d="M19.2 12a7.5 7.5 0 0 0-.1-1l2-1.5-2-3.4-2.4.8a7.8 7.8 0 0 0-1.7-1l-.4-2.5h-4l-.4 2.5a7.8 7.8 0 0 0-1.7 1l-2.4-.8-2 3.4 2 1.5a7.5 7.5 0 0 0 0 2l-2 1.5 2 3.4 2.4-.8a7.8 7.8 0 0 0 1.7 1l.4 2.5h4l.4-2.5a7.8 7.8 0 0 0 1.7-1l2.4.8 2-3.4-2-1.5c.1-.3.1-.7.1-1z"></path></svg>'],
          ['extra ferme', '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M5 8h14"></path><path d="M5 12h14"></path><path d="M5 16h14"></path></svg>'],
          ['extra-ferme', '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M5 8h14"></path><path d="M5 12h14"></path><path d="M5 16h14"></path></svg>'],
          ['très ferme', '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M5 8h14"></path><path d="M5 12h14"></path><path d="M5 16h14"></path></svg>'],
          ['tres ferme', '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M5 8h14"></path><path d="M5 12h14"></path><path d="M5 16h14"></path></svg>'],
          ['ferme', '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M5 10h14"></path><path d="M5 15h14"></path></svg>'],
          ['medium', '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M5 12h14"></path></svg>'],
          ['médium', '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M5 12h14"></path></svg>'],
          ['souple', '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M3 16h18"></path><path d="M12 9.4v7.8"></path><path d="M10.4 13.6 12 15.2l1.6-1.6"></path><path d="M6 16q6.2-4.4 12 0"></path></svg>'],
          ['moelleux', '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M3 16h18"></path><path d="M12 10.8v8"></path><path d="M10.6 14.8 12 16.2l1.4-1.4"></path><path d="M5.8 16q6.6-5.6 12.4 0"></path></svg>']
        ]);
        comfortStep.querySelectorAll('.mdl-mattress-advisor__choice').forEach((button) => {
          const labelNode = button.querySelector('span');
          if (!labelNode) return;
          if (button.querySelector('.mdl-mattress-advisor__choice-main')) return;
          const label = (button.dataset.filterLabel || labelNode.textContent || '').toLowerCase();
          let iconSvg = '';
          for (const [needle, svg] of comfortIconByLabel.entries()) {
            if (label.includes(needle)) {
              iconSvg = svg;
              break;
            }
          }
          const mainNode = document.createElement('span');
          mainNode.className = 'mdl-mattress-advisor__choice-main';
          if (iconSvg) {
            const iconNode = document.createElement('span');
            iconNode.className = 'mdl-mattress-advisor__choice-icon';
            iconNode.setAttribute('aria-hidden', 'true');
            iconNode.innerHTML = iconSvg;
            mainNode.appendChild(iconNode);
          }
          labelNode.replaceWith(mainNode);
          mainNode.appendChild(labelNode);
        });
      };

      advisor.addEventListener('click', (event) => {
        const choice = event.target.closest('.mdl-mattress-advisor__choice');
        if (!choice || !advisor.contains(choice)) return;
        if (choice.hasAttribute('data-open-comfort-help')) {
          openComfortHelp();
          return;
        }
        selectChoice(choice);
      });

      prevButtons.forEach((button) => {
        button.addEventListener('click', () => goTo(currentIndex - 1));
      });
      nextButtons.forEach((button) => {
        button.addEventListener('click', () => goTo(currentIndex + 1));
      });

      if (mainActionButton) {
        mainActionButton.addEventListener('click', () => {
          if (panelOpen || advisor.classList.contains('has-results')) {
            const resetTarget = buildResetUrl();
            answers.clear();
            selectedWidth = null;
            selectedOccupancy = null;
            answeredSteps.clear();
            autoSkippedSteps.clear();
            advisor.classList.remove('has-results');
            advisor.querySelectorAll('.mdl-mattress-advisor__choice').forEach((choice) => {
              choice.classList.remove('is-selected');
              choice.setAttribute('aria-pressed', 'false');
            });
            renderLengthChoices();
            setPanelOpen(true);
            goTo(0);
            maybeAutoAdvanceSingles();
            window.setTimeout(() => {
              window.location.href = resetTarget.toString();
            }, 60);
            return;
          }

          setPanelOpen(true);
          animateExpandToCurrentStep();
          updateViewportHeight();
          if (expanded) {
            window.requestAnimationFrame(() => {
              const targetTop = expanded.getBoundingClientRect().top + window.scrollY;
              window.scrollTo({ top: Math.max(0, Math.round(targetTop)), behavior: 'smooth' });
            });
          }
        });
      }

      resetButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const resetTarget = buildResetUrl();
          answers.clear();
          selectedWidth = null;
          selectedOccupancy = null;
          answeredSteps.clear();
          autoSkippedSteps.clear();
          advisor.querySelectorAll('.mdl-mattress-advisor__choice').forEach((choice) => {
            choice.classList.remove('is-selected');
            choice.setAttribute('aria-pressed', 'false');
          });
          renderLengthChoices();
          advisor.classList.remove('has-results');
          setPanelOpen(true);
          goTo(0);
          maybeAutoAdvanceSingles();

          window.setTimeout(() => {
            window.location.href = resetTarget.toString();
          }, 60);
        });
      });

      renderOccupancyChoices();
      renderWidthChoices();
      renderLengthChoices();
      decorateComfortIcons();
      setPanelOpen(false);
      updateUi();
      maybeAutoAdvanceSingles();
      updateViewportHeight();

      try {
        const saved = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY) || 'null');
        if (saved && saved.path === window.location.pathname) {
          window.sessionStorage.removeItem(STORAGE_KEY);
          if (collapsedSummary) {
            collapsedSummary.innerHTML = '';
            (saved.labels && saved.labels.length ? saved.labels : ['Sélection appliquée']).forEach((label) => {
              const item = document.createElement('span');
              item.textContent = label;
              collapsedSummary.appendChild(item);
            });
          }
          advisor.classList.add('has-results');
          setPanelOpen(false);
          const selectionHeading = injectSelectionHeadingBeforeListing(advisor);
          const target = findProductTarget(advisor);
          window.setTimeout(() => {
            if (selectionHeading) {
              selectionHeading.scrollIntoView({ behavior: 'smooth', block: 'start' });
            } else if (target) {
              target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
            if (target) {
              target.classList.add('mdl-mattress-advisor-product-flash');
              window.setTimeout(() => target.classList.remove('mdl-mattress-advisor-product-flash'), 1300);
            }
          }, 500);
        }
        if (!saved || saved.path !== window.location.pathname) {
          removeSelectionHeading();
        }
      } catch (error) {
        // Ignore malformed saved state.
      }
    });
  })();
  }

  (() => {
    const STORAGE_KEY = 'mdlMattressAdvisorState';
    const advisors = document.querySelectorAll('[data-mattress-advisor]');

    const normalizeSizeLabel = (label) => String(label || '').replace(/\s+/g, ' ').trim();
    const parseSize = (label) => {
      const match = normalizeSizeLabel(label).match(/(\d{2,3})\s*x\s*(\d{3})/i);
      if (!match) return null;
      return { width: Number(match[1]), length: Number(match[2]) };
    };

    const computeComfortRecommendation = (profile) => {
      let base = 'medium';
      if (profile.accueil === 'cocon') base = 'moelleux';
      if (profile.accueil === 'tonique') base = 'ferme';
      if (profile.position === 'ventre') base = 'ferme';
      if (profile.position === 'dos' && base === 'moelleux') base = 'medium';
      if (profile.position === 'cote' && base === 'ferme') base = 'medium';
      if (profile.position === 'mixte' && base === 'moelleux') base = 'medium';
      if (profile.poids === 'lourd' && base !== 'ferme') base = 'ferme';
      if (profile.poids === 'leger' && base === 'ferme') base = 'medium';
      return base;
    };

    const findProductTarget = (advisor) => {
      const section = advisor.closest('.shopify-section');
      let sibling = section ? section.nextElementSibling : null;
      while (sibling) {
        const id = sibling.id || '';
        if (id.includes('__collection') || sibling.querySelector('facet-filters-form, product-card, .product-card, [data-product-card], .boost-sd__product-item')) {
          return sibling;
        }
        sibling = sibling.nextElementSibling;
      }
      return document.querySelector('facet-filters-form, .boost-sd__collection, [data-products-grid], product-list') || document.querySelector('main');
    };

    const removeSelectionHeading = () => {
      document.querySelectorAll('.mdl-mattress-advisor-selection-heading').forEach((node) => node.remove());
    };

    const injectSelectionHeadingBeforeListing = (advisor) => {
      removeSelectionHeading();
      const target = findProductTarget(advisor);
      if (!target || !target.parentNode) return null;
      const heading = document.createElement('h2');
      heading.className = 'mdl-mattress-advisor-selection-heading';
      heading.textContent = 'Votre sélection';
      target.parentNode.insertBefore(heading, target);
      return heading;
    };

    const findQuickSizeNavBlock = (advisor) => {
      const section = advisor.closest('.shopify-section');
      let sibling = section ? section.nextElementSibling : null;
      while (sibling) {
        if (sibling.querySelector('layer-action[layer-id="collection-filters"]') || sibling.textContent.includes('Toutes les tailles')) {
          return sibling;
        }
        sibling = sibling.nextElementSibling;
      }
      return null;
    };

    const parseSizeOptionsFromRoot = (root) => Array.from(root.querySelectorAll('[data-size-option]')).map((node) => {
      const parsed = parseSize(node.dataset.filterLabel || node.dataset.filterValue);
      if (!parsed) return null;
      return {
        ...parsed,
        param: node.dataset.filterParam || '',
        value: node.dataset.filterValue || '',
        label: normalizeSizeLabel(node.dataset.filterLabel || node.dataset.filterValue),
        count: Number(node.dataset.sizeCount || 0),
      };
    }).filter(Boolean);

    const allowedSizeLabels = new Set([
      '80 x 190',
      '80 x 200',
      '140 x 190',
      '160 x 200',
      '180 x 200',
      '200 x 200',
    ]);

    const filterAllowedSizeOptions = (options) => options.filter((option) => {
      const key = `${option.width} x ${option.length}`;
      return allowedSizeLabels.has(key);
    });

    const buildSizeDescription = (option) => {
      if (option.width >= 160) return 'Grand confort pour deux personnes';
      if (option.width >= 140) return 'Format duo classique';
      if (option.width >= 100) return option.length >= 200 ? 'Solo spacieux pour grands dormeurs' : 'Solo grand confort';
      return option.length >= 200 ? 'Format solo long' : 'Format solo standard';
    };

    advisors.forEach((advisor) => {
      if (advisor.dataset.mdlReordered === 'true') return;
      advisor.dataset.mdlReordered = 'true';

      const track = advisor.querySelector('[data-advisor-track]');
      const steps = Array.from(advisor.querySelectorAll('[data-advisor-step]'));
      const collapsed = advisor.querySelector('[data-advisor-collapsed]');
      const expanded = advisor.querySelector('[data-advisor-expanded]');
      const prevButtons = Array.from(advisor.querySelectorAll('[data-advisor-prev]'));
      const nextButtons = Array.from(advisor.querySelectorAll('[data-advisor-next]'));
      const mainActionButton = advisor.querySelector('[data-advisor-main-action]');
      const progressNodes = Array.from(advisor.querySelectorAll('[data-advisor-progress]'));
      const collapsedSummary = advisor.querySelector('[data-advisor-collapsed-summary]');
      const sizeHint = advisor.querySelector('[data-size-hint]');
      const sizeChoices = advisor.querySelector('[data-size-choices]');
      const collectionUrl = advisor.dataset.collectionUrl || window.location.pathname;
      const answers = new Map();
      const answeredSteps = new Set();
      const baseSizeOptions = filterAllowedSizeOptions(parseSizeOptionsFromRoot(advisor)).sort((a, b) => (b.width - a.width) || (b.length - a.length));
      const comfortOptions = Array.from(advisor.querySelectorAll('[data-comfort-option]')).map((node) => ({
        param: node.dataset.filterParam || '',
        value: node.dataset.filterValue || '',
        label: node.dataset.filterLabel || '',
      }));
      const sizeCache = new Map();
      const profile = { accueil: '', position: '', poids: '' };
      let currentIndex = 0;
      let panelOpen = false;
      let isLoadingSizes = false;
      let availableSizeOptions = [...baseSizeOptions];

      const updateViewportHeight = () => {
        const viewport = advisor.querySelector('.mdl-mattress-advisor__viewport');
        const activeStep = steps[currentIndex];
        if (!viewport || !activeStep) return;
        viewport.style.height = `${activeStep.offsetHeight}px`;
      };

      const updateMainActionLabel = () => {
        if (!mainActionButton) return;
        mainActionButton.textContent = panelOpen || advisor.classList.contains('has-results') ? 'Recommencer' : 'Commencer >';
      };

      const setPanelOpen = (isOpen) => {
        panelOpen = isOpen;
        advisor.classList.toggle('is-collapsed', !isOpen);
        if (collapsed) collapsed.hidden = false;
        if (expanded) expanded.hidden = !isOpen;
        const quickSizeNav = findQuickSizeNavBlock(advisor);
        if (quickSizeNav) quickSizeNav.hidden = isOpen;
        updateMainActionLabel();
      };

      const updateUi = () => {
        if (track) track.style.transform = `translateX(-${currentIndex * 100}%)`;
        prevButtons.forEach((button) => {
          button.disabled = currentIndex === 0 || isLoadingSizes;
        });
        nextButtons.forEach((button) => {
          button.disabled = currentIndex >= steps.length - 1 || !answeredSteps.has(currentIndex) || isLoadingSizes;
        });
        progressNodes.forEach((node) => {
          node.textContent = `${currentIndex + 1}/${steps.length}`;
        });
        updateViewportHeight();
      };

      const goTo = (index) => {
        currentIndex = Math.max(0, Math.min(index, steps.length - 1));
        updateUi();
      };

      const buildSummary = () => {
        if (!collapsedSummary) return;
        collapsedSummary.innerHTML = '';
        const labels = Array.from(answers.values()).map((answer) => answer.summaryLabel || answer.label).filter(Boolean);
        if (!labels.length) {
          advisor.classList.remove('has-results');
          const item = document.createElement('span');
          item.textContent = 'Tous les matelas';
          collapsedSummary.appendChild(item);
          return;
        }
        advisor.classList.add('has-results');
        labels.forEach((label) => {
          const item = document.createElement('span');
          item.textContent = label;
          collapsedSummary.appendChild(item);
        });
      };

      const buildTargetUrl = () => {
        const target = new URL(collectionUrl, window.location.origin);
        target.searchParams.set('sort_by', 'price-ascending');
        answers.forEach((answer) => {
          if (answer.param && answer.value) target.searchParams.append(answer.param, answer.value);
        });
        return target;
      };

      const setSelectedChoice = (step, choice) => {
        step.querySelectorAll('.mdl-mattress-advisor__choice').forEach((button) => {
          button.classList.remove('is-selected');
          button.setAttribute('aria-pressed', 'false');
        });
        choice.classList.add('is-selected');
        choice.setAttribute('aria-pressed', 'true');
      };

      const resolveComfortCandidates = (recommendation) => {
        const groups = {
          moelleux: ['moelleux', 'souple'],
          medium: ['medium', 'médium', 'equilibr', 'équilibr'],
          ferme: ['extra', 'ferme'],
        };
        const order = recommendation === 'moelleux'
          ? ['moelleux', 'medium', 'ferme']
          : recommendation === 'ferme'
            ? ['ferme', 'medium', 'moelleux']
            : ['medium', 'ferme', 'moelleux'];

        const matched = [];
        order.forEach((key) => {
          const needles = groups[key] || [];
          comfortOptions.forEach((option) => {
            const label = option.label.toLowerCase();
            if (needles.some((needle) => label.includes(needle)) && !matched.includes(option)) matched.push(option);
          });
        });
        comfortOptions.forEach((option) => {
          if (!matched.includes(option)) matched.push(option);
        });
        return matched;
      };

      const fetchSizeOptionsForComfort = async (comfortOption) => {
        const cacheKey = comfortOption ? `${comfortOption.param}::${comfortOption.value}` : 'all';
        if (sizeCache.has(cacheKey)) return sizeCache.get(cacheKey);
        const fallback = [...baseSizeOptions];
        if (!comfortOption?.param || !comfortOption?.value) {
          sizeCache.set(cacheKey, fallback);
          return fallback;
        }
        try {
          const target = new URL(collectionUrl, window.location.origin);
          target.searchParams.append(comfortOption.param, comfortOption.value);
          target.searchParams.set('sort_by', 'price-ascending');
          const response = await fetch(target.toString(), { credentials: 'same-origin' });
          if (!response.ok) throw new Error(`HTTP ${response.status}`);
          const html = await response.text();
          const doc = new window.DOMParser().parseFromString(html, 'text/html');
          const parsed = filterAllowedSizeOptions(parseSizeOptionsFromRoot(doc)).sort((a, b) => (b.width - a.width) || (b.length - a.length));
          const result = parsed.length ? parsed : fallback;
          sizeCache.set(cacheKey, result);
          return result;
        } catch (error) {
          sizeCache.set(cacheKey, fallback);
          return fallback;
        }
      };

      const renderSizeChoices = () => {
        if (!sizeChoices) return;
        sizeChoices.innerHTML = '';
        if (!availableSizeOptions.length) {
          const empty = document.createElement('small');
          empty.className = 'mdl-mattress-advisor__hint';
          empty.textContent = 'Aucune taille disponible pour cette recommandation.';
          sizeChoices.appendChild(empty);
          return;
        }
        availableSizeOptions.forEach((option) => {
          const button = document.createElement('button');
          button.className = 'mdl-mattress-advisor__choice';
          button.type = 'button';
          button.setAttribute('aria-pressed', 'false');
          button.dataset.answerKey = 'size';
          button.dataset.filterParam = option.param;
          button.dataset.filterValue = option.value;
          button.dataset.filterLabel = option.label;
          button.dataset.summaryLabel = `${option.width} x ${option.length} cm`;
          button.innerHTML = `<span class="mdl-mattress-advisor__choice-main"><span class="mdl-mattress-advisor__choice-icon" aria-hidden="true">□</span><span>${option.width} x ${option.length} cm</span></span><em>${buildSizeDescription(option)}</em>`;
          sizeChoices.appendChild(button);
        });
      };

      const prepareSizeStep = async () => {
        isLoadingSizes = true;
        answeredSteps.delete(3);
        if (sizeHint) sizeHint.textContent = 'Recherche des tailles compatibles en cours...';
        if (sizeChoices) sizeChoices.innerHTML = '';
        updateUi();

        const recommendation = computeComfortRecommendation(profile);
        const candidates = resolveComfortCandidates(recommendation);
        let selectedComfort = null;
        let selectedSizes = [];

        for (const candidate of candidates) {
          const candidateSizes = await fetchSizeOptionsForComfort(candidate);
          if (candidateSizes.length) {
            selectedComfort = candidate;
            selectedSizes = candidateSizes;
            break;
          }
        }

        availableSizeOptions = selectedSizes.length ? selectedSizes : [...baseSizeOptions];
        if (selectedComfort) {
          answers.set('comfort', {
            param: selectedComfort.param,
            value: selectedComfort.value,
            label: selectedComfort.label,
            summaryLabel: `Confort conseillé: ${selectedComfort.label}`,
          });
          if (sizeHint) sizeHint.textContent = `Tailles avec résultats pour le confort conseillé: ${selectedComfort.label}.`;
        } else {
          answers.delete('comfort');
          if (sizeHint) sizeHint.textContent = 'Tailles disponibles actuellement.';
        }

        renderSizeChoices();
        isLoadingSizes = false;
        updateUi();
      };

      const resetState = () => {
        answers.clear();
        answeredSteps.clear();
        profile.accueil = '';
        profile.position = '';
        profile.poids = '';
        availableSizeOptions = [...baseSizeOptions];
        isLoadingSizes = false;
        advisor.classList.remove('has-results');
        advisor.querySelectorAll('.mdl-mattress-advisor__choice').forEach((choice) => {
          choice.classList.remove('is-selected');
          choice.setAttribute('aria-pressed', 'false');
        });
        if (sizeHint) sizeHint.textContent = 'Nous allons charger uniquement les tailles qui gardent des résultats.';
        if (sizeChoices) sizeChoices.innerHTML = '';
        currentIndex = 0;
        updateUi();
      };

      const applyFilters = () => {
        buildSummary();
        setPanelOpen(false);
        advisor.classList.add('is-applying');
        const target = buildTargetUrl();
        const summaryLabels = Array.from(answers.values()).map((answer) => answer.summaryLabel || answer.label).filter(Boolean);
        try {
          window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ path: target.pathname, labels: summaryLabels, flash: true }));
        } catch (error) {
          // Ignore storage errors.
        }
        window.setTimeout(() => {
          window.location.href = target.toString();
        }, 180);
      };

      const handleChoice = async (choice) => {
        const step = choice.closest('[data-advisor-step]');
        const stepIndex = steps.indexOf(step);
        if (stepIndex < 0 || isLoadingSizes) return;
        setSelectedChoice(step, choice);
        answeredSteps.add(stepIndex);

        const answerKey = choice.dataset.answerKey || '';
        const answerValue = choice.dataset.answerValue || '';
        if (answerKey === 'accueil' || answerKey === 'position' || answerKey === 'poids') {
          profile[answerKey] = answerValue;
          answers.set(answerKey, {
            label: choice.dataset.filterLabel || choice.textContent || '',
            summaryLabel: choice.dataset.filterLabel || choice.textContent || '',
          });
          if (answerKey === 'poids') {
            await prepareSizeStep();
          }
        }

        if (answerKey === 'size') {
          answers.set('size', {
            param: choice.dataset.filterParam,
            value: choice.dataset.filterValue,
            label: choice.dataset.filterLabel,
            summaryLabel: choice.dataset.summaryLabel || choice.dataset.filterLabel,
          });
        }

        if (stepIndex >= steps.length - 1) {
          window.setTimeout(applyFilters, 180);
          return;
        }

        window.setTimeout(() => {
          goTo(stepIndex + 1);
        }, 140);
      };

      advisor.addEventListener('click', (event) => {
        const choice = event.target.closest('.mdl-mattress-advisor__choice');
        if (!choice || !advisor.contains(choice)) return;
        void handleChoice(choice);
      });

      prevButtons.forEach((button) => {
        button.addEventListener('click', () => goTo(currentIndex - 1));
      });
      nextButtons.forEach((button) => {
        button.addEventListener('click', () => goTo(currentIndex + 1));
      });

      if (mainActionButton) {
        mainActionButton.addEventListener('click', () => {
          if (panelOpen || advisor.classList.contains('has-results')) {
            resetState();
            setPanelOpen(true);
            const resetTarget = new URL(collectionUrl, window.location.origin);
            window.setTimeout(() => {
              window.location.href = resetTarget.toString();
            }, 60);
            return;
          }

          setPanelOpen(true);
          updateViewportHeight();
          if (expanded) {
            window.requestAnimationFrame(() => {
              const targetTop = expanded.getBoundingClientRect().top + window.scrollY;
              window.scrollTo({ top: Math.max(0, Math.round(targetTop)), behavior: 'smooth' });
            });
          }
        });
      }

      setPanelOpen(false);
      resetState();

      try {
        const saved = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY) || 'null');
        if (saved && saved.path === window.location.pathname) {
          window.sessionStorage.removeItem(STORAGE_KEY);
          if (collapsedSummary) {
            collapsedSummary.innerHTML = '';
            (saved.labels && saved.labels.length ? saved.labels : ['Sélection appliquée']).forEach((label) => {
              const item = document.createElement('span');
              item.textContent = label;
              collapsedSummary.appendChild(item);
            });
          }
          advisor.classList.add('has-results');
          setPanelOpen(false);
          const selectionHeading = injectSelectionHeadingBeforeListing(advisor);
          const target = findProductTarget(advisor);
          window.setTimeout(() => {
            if (selectionHeading) {
              selectionHeading.scrollIntoView({ behavior: 'smooth', block: 'start' });
            } else if (target) {
              target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          }, 500);
        } else {
          removeSelectionHeading();
        }
      } catch (error) {
        removeSelectionHeading();
      }
    });
  })();

  (() => {
    const quiz = document.querySelector('[data-needs-quiz]');
    if (!quiz) return;

    const toggle = quiz.querySelector('[data-needs-toggle]');
    const panel = quiz.querySelector('[data-needs-panel]');
    const steps = Array.from(quiz.querySelectorAll('[data-needs-step]'));
    const result = quiz.querySelector('[data-needs-result]');
    const summary = quiz.querySelector('[data-needs-summary]');
    const progress = quiz.querySelector('[data-needs-progress]');
    const prev = quiz.querySelector('[data-needs-prev]');
    const next = quiz.querySelector('[data-needs-next]');
    const apply = quiz.querySelector('[data-needs-apply]');
    const reset = quiz.querySelector('[data-needs-reset]');
    const widthChoices = quiz.querySelector('[data-needs-width-choices]');
    const lengthChoices = quiz.querySelector('[data-needs-length-choices]');
    const lengthHint = quiz.querySelector('[data-needs-length-hint]');
    const collectionUrl = quiz.dataset.collectionUrl || window.location.pathname;
    const sizeOptions = Array.from(document.querySelectorAll('[data-size-option]')).map((node) => {
      const label = String(node.dataset.filterLabel || '').replace(/\s+/g, ' ').trim();
      const match = label.match(/(\d{2,3})\s*x\s*(\d{3})/i);
      if (!match) return null;
      return {
        width: Number(match[1]),
        length: Number(match[2]),
        param: node.dataset.filterParam,
        value: node.dataset.filterValue,
        label,
      };
    }).filter(Boolean);
    const comfortOptions = Array.from(document.querySelectorAll('[data-comfort-option]')).map((node) => ({
      label: String(node.dataset.filterLabel || ''),
      param: node.dataset.filterParam || '',
      value: node.dataset.filterValue || '',
    }));

    const answers = {};
    let selectedWidth = null;
    let selectedSizeOption = null;
    let stepIndex = 0;

    const stepOrder = ['comfort', 'position', 'occupancy', 'width', 'length'];

    const resolveComfortFilter = (segment) => {
      const checks = {
        moelleux: ['souple', 'moelleux'],
        equilibre: ['medium', 'médium', 'equilibre', 'équilibré'],
        ferme: ['extra', 'ferme']
      };
      const needles = checks[segment] || [];
      const found = comfortOptions.find((option) => {
        const label = option.label.toLowerCase();
        return needles.some((needle) => label.includes(needle));
      });
      return found || comfortOptions[0] || null;
    };

    const setSelected = (choice) => {
      const container = choice.closest('.mdl-needs-quiz__choices');
      if (!container) return;
      container.querySelectorAll('.mdl-needs-quiz__choice').forEach((button) => button.classList.remove('is-selected'));
      choice.classList.add('is-selected');
    };

    const renderStep = () => {
      steps.forEach((step, idx) => step.classList.toggle('is-active', idx === stepIndex));
      if (result) result.hidden = true;
      if (progress) progress.textContent = `${Math.min(stepIndex + 1, stepOrder.length)}/${stepOrder.length}`;
      if (prev) prev.disabled = stepIndex === 0;
      if (next) {
        const activeKey = stepOrder[stepIndex];
        next.disabled = !answers[activeKey];
      }
    };

    const goTo = (index) => {
      stepIndex = Math.max(0, Math.min(index, stepOrder.length - 1));
      renderStep();
    };

    const renderWidthChoices = () => {
      if (!widthChoices) return;
      const occupancy = answers.occupancy;
      const filtered = sizeOptions.filter((option) => {
        if (occupancy === 'one') return option.width <= 120;
        if (occupancy === 'two') return option.width >= 140;
        return true;
      });
      const widths = Array.from(new Set(filtered.map((option) => option.width))).sort((a, b) => b - a);
      widthChoices.innerHTML = '';
      widths.forEach((width) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'mdl-needs-quiz__choice';
        btn.dataset.needsAnswer = 'width';
        btn.dataset.needsValue = String(width);
        btn.innerHTML = `<span>${width} cm</span><em>${occupancy === 'one' ? 'Format solo' : 'Format duo'}</em>`;
        widthChoices.appendChild(btn);
      });
    };

    const renderLengthChoices = () => {
      if (!lengthChoices) return;
      const options = sizeOptions.filter((option) => option.width === selectedWidth).sort((a, b) => b.length - a.length);
      lengthChoices.innerHTML = '';
      if (lengthHint) lengthHint.textContent = selectedWidth ? `Largeur sélectionnée : ${selectedWidth} cm` : '';
      options.forEach((option) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'mdl-needs-quiz__choice';
        btn.dataset.needsAnswer = 'length';
        btn.dataset.needsValue = String(option.length);
        btn.innerHTML = `<span>${option.length} cm</span><em>${option.length >= 200 ? 'Longueur confort' : 'Longueur standard'}</em>`;
        btn.addEventListener('click', () => {
          selectedSizeOption = option;
        });
        lengthChoices.appendChild(btn);
      });
    };

    const openQuiz = () => {
      if (!panel) return;
      panel.hidden = false;
      Object.keys(answers).forEach((key) => delete answers[key]);
      selectedWidth = null;
      selectedSizeOption = null;
      quiz.querySelectorAll('.mdl-needs-quiz__choice').forEach((choice) => choice.classList.remove('is-selected'));
      stepIndex = 0;
      renderStep();
      if (toggle) toggle.textContent = 'Recommencer';
    };

    const showResult = () => {
      if (!summary || !result) return;
      steps.forEach((step) => step.classList.remove('is-active'));
      summary.innerHTML = '';
      const labels = [
        ['Confort', answers.comfort_label],
        ['Position', answers.position],
        ['Nombre', answers.occupancy === 'two' ? '2 personnes' : '1 personne'],
        ['Taille', selectedSizeOption ? `${selectedSizeOption.width} x ${selectedSizeOption.length} cm` : '']
      ];
      labels.forEach(([key, value]) => {
        if (!value) return;
        const chip = document.createElement('span');
        chip.textContent = `${key}: ${value}`;
        summary.appendChild(chip);
      });
      result.hidden = false;
      if (progress) progress.textContent = `${stepOrder.length}/${stepOrder.length}`;
      if (prev) prev.disabled = false;
      if (next) next.disabled = true;
    };

    const applyFilters = () => {
      const target = new URL(collectionUrl, window.location.origin);
      const current = new URL(window.location.href);
      const sortBy = current.searchParams.get('sort_by');
      if (sortBy) target.searchParams.set('sort_by', sortBy);

      if (answers.comfort_option?.param && answers.comfort_option?.value) {
        target.searchParams.append(answers.comfort_option.param, answers.comfort_option.value);
      }
      if (selectedSizeOption?.param && selectedSizeOption?.value) {
        target.searchParams.append(selectedSizeOption.param, selectedSizeOption.value);
      }
      window.location.href = target.toString();
    };

    quiz.addEventListener('click', (event) => {
      const choice = event.target.closest('[data-needs-answer]');
      if (!choice) return;
      const answerKey = choice.dataset.needsAnswer;
      const answerValue = choice.dataset.needsValue;
      if (!answerKey || !answerValue) return;
      setSelected(choice);

      if (answerKey === 'comfort') {
        answers.comfort = answerValue;
        answers.comfort_option = resolveComfortFilter(answerValue);
        answers.comfort_label = choice.querySelector('span')?.textContent || '';
      } else if (answerKey === 'position') {
        answers.position = answerValue;
      } else if (answerKey === 'occupancy') {
        answers.occupancy = answerValue;
        selectedWidth = null;
        selectedSizeOption = null;
        answers.width = '';
        answers.length = '';
        renderWidthChoices();
      } else if (answerKey === 'width') {
        selectedWidth = Number(answerValue);
        answers.width = answerValue;
        selectedSizeOption = null;
        answers.length = '';
        renderLengthChoices();
      } else if (answerKey === 'length') {
        answers.length = answerValue;
        const match = sizeOptions.find((option) => option.width === selectedWidth && option.length === Number(answerValue));
        if (match) selectedSizeOption = match;
      }

      const activeKey = stepOrder[stepIndex];
      if (answers[activeKey] && stepIndex < stepOrder.length - 1) {
        goTo(stepIndex + 1);
      } else if (answers.length && selectedSizeOption) {
        showResult();
      } else {
        renderStep();
      }
    });

    if (prev) prev.addEventListener('click', () => goTo(stepIndex - 1));
    if (next) next.addEventListener('click', () => goTo(stepIndex + 1));

    if (toggle) {
      toggle.addEventListener('click', () => {
        openQuiz();
      });
    }

    if (reset) {
      reset.addEventListener('click', () => {
        openQuiz();
      });
    }

    if (apply) {
      apply.addEventListener('click', applyFilters);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
